import { ACDLRoute, BaseRouteConfig } from './BaseRoute';

export class IntegrationsPath extends BaseRouteConfig {
  public readonly Index = 'api';

  public readonly List = {
    Path: new ACDLRoute<{ workspaceId: string }>(`${this.Path}/list`),
    All: new ACDLRoute<{ workspaceId: string }>(`${this.Path}/list/all`),
  };
}
